import React from 'react';
import { View } from 'react-native';
import { GeolocationRequirement } from '../../../api/api.g';
import useTranslation from '../../../hooks/translation-hook';
import ProfileModal from '../../myaccount/myprofile/ProfileModal';
import Label from '../Label';

interface GeolocationAcceptanceModalProps {
  requirement: GeolocationRequirement;
  radius?: number;
  onContinue(): void;
}

const GeolocationAcceptanceModal = ({ requirement, radius, onContinue }: GeolocationAcceptanceModalProps) => {
  const t = useTranslation();
  const message =
    requirement === GeolocationRequirement.Required
      ? t('geolocation-check-in-required-acceptance', { radius: radius ?? 500 })
      : t('geolocation-check-in-optional-acceptance', { radius: radius ?? 500 });

  return (
    <ProfileModal
      title={t('geolocation-check-in-title')}
      hideCloseButton
      confirmText={requirement === GeolocationRequirement.Optional ? t('Later') : t('Continue')}
      onConfirm={onContinue}
    >
      <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 40 }}>
        <Label style={{ marginTop: 8, textAlign: 'center' }} numberOfLines={10}>
          {message}
        </Label>
      </View>
    </ProfileModal>
  );
};

export default GeolocationAcceptanceModal;
